const endpoint = "https://blw-can-api.herokuapp.com/api/";

const getOptions = (dict) => {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(dict),
  };
};

const getEndpoint = (url) => `${endpoint}${url}`;

export { endpoint, getOptions, getEndpoint };
